import React, { Component } from 'react';
import './App.css';
import Map from './Map';


class App extends Component {

  getQueryString(field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    var string = reg.exec(href);
    return string ? string[1] : null;
  }

  // t1=58 - 1164&f1=FAF9C5&t2=1164 - 3215&f2=FAF605&t3=3215 - 6450&f3=FAD046&t4=6450 - 13004&f4=FA9C05&t5=13004 - 33030&f5=FA0505&sld_title=geodb:view_censo

  mountParams() {

    const tipo_mapa = this.getQueryString('tipo_mapa');

    let ano = this.getQueryString('ano');
    let produto = this.getQueryString('produto');
    let regiao = this.getQueryString('regiao');
    let bacia = this.getQueryString('bacia');
    let uf = this.getQueryString('uf');
    let nivel = this.getQueryString('nivel');
    let territorio = this.getQueryString('territorio');
    let variavel = this.getQueryString('variavel');
    let id_bacia = this.getQueryString('id_bacia');
    let ano_inicial = this.getQueryString('ano_inicial');
    let ano_final = this.getQueryString('ano_final');
    
    ano = ano === null ? ano : decodeURIComponent(ano);
    produto = produto === null ? produto : decodeURIComponent(produto);
    regiao = regiao === null ? regiao : decodeURIComponent(regiao);
    bacia = bacia === null ? bacia : decodeURIComponent(bacia);
    uf = uf === null ? uf : decodeURIComponent(uf);
    nivel = nivel === null ? nivel : decodeURIComponent(nivel);
    territorio = territorio === null ? territorio : decodeURIComponent(territorio);
    variavel = variavel === null ? variavel : decodeURIComponent(variavel);
    id_bacia = id_bacia === null ? id_bacia : decodeURIComponent(id_bacia);
    ano_inicial = ano_inicial === null ? ano_inicial : decodeURIComponent(ano_inicial);
    ano_final = ano_final === null ? ano_final : decodeURIComponent(ano_final);

    // aplica o decodeURIComponent para os parâmetros - para garantir que os valores recebidos com acentuação funcionem
    
    return {ano, produto, regiao, bacia, uf, nivel, territorio, variavel, tipo_mapa, id_bacia, ano_inicial, ano_final};
    
  }

  render() {

    const params = this.mountParams();

    return (

      <div className="container-fluid">
        <div className="card card-map text-center">
          {/*          
          <div className="card-header">
            Mapas do Sistema de Macrologistica
          </div>
          */}
          <div className="card-body card-body-map">
            <Map params={params} />
          </div>

          {/*          
          <div className="card-footer text-left">
          </div>
          */}
          
        </div>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js